var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestReportLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "562px",
    height: "104px",
    viewBox: "0 0 562 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-print",
    transform: "translate(-258, -488)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(258.9631, 488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "testreport",
    transform: "translate(147.4753, 26.8176)",
    fill: "#222229"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5504,53.5808 C24.0448,53.5808 26.8736,52.832 28.7872,52.3328 L28.7872,41.0176 C27.456,41.5168 26.208,41.7664 24.544,41.7664 C21.7152,41.7664 20.1344,40.352 20.1344,37.1904 L20.1344,19.2192 L28.704,19.2192 L28.704,9.0688 L20.1344,9.0688 L20.1344,7.10542736e-15 L5.2416,7.10542736e-15 L5.2416,9.0688 L0,9.0688 L0,19.2192 L5.2416,19.2192 L5.2416,38.6048 C5.2416,48.8384 10.7328,53.5808 20.5504,53.5808 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9088,53.5808 C70.0544,53.5808 77.6256,48.0064 78.9568,38.1888 L64.9792,38.1888 C64.3968,41.1008 62.3168,43.3472 57.408,43.3472 C52.0832,43.3472 48.7552,40.0192 48.3392,34.2784 L78.9568,34.2784 L78.9568,30.368 C78.9568,14.7264 68.7232,7.904 56.8256,7.904 C43.68,7.904 33.28,16.7232 33.28,30.7008 L33.28,31.3664 C33.28,45.5936 43.264,53.5808 56.9088,53.5808 Z M48.5056,25.8752 C49.2544,20.6336 52.3328,17.7216 56.8256,17.7216 C61.6512,17.7216 64.2304,20.6336 64.48,25.8752 L48.5056,25.8752 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.8352,53.5808 C114.8992,53.5808 122.5536,48.9216 122.5536,38.6048 C122.5536,29.2864 116.7296,26.1248 104.6656,24.6272 C99.3408,23.9616 97.344,23.1296 97.344,21.0496 C97.344,19.0528 99.008,17.6384 102.2528,17.6384 C105.664,17.6384 107.2448,19.0528 107.8272,21.9648 L121.3056,21.9648 C120.3072,11.5648 112.8192,7.904 102.0864,7.904 C92.0192,7.904 83.4496,12.5632 83.4496,22.2144 C83.4496,31.2832 88.3584,34.6944 100.0064,36.192 C105.9968,37.024 108.0768,38.0224 108.0768,40.1024 C108.0768,42.2656 106.4128,43.68 102.752,43.68 C98.5088,43.68 97.0944,41.9328 96.5952,38.7712 L82.8672,38.7712 C83.2,48.4224 90.4384,53.5808 102.8352,53.5808 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.9328,53.5808 C149.4272,53.5808 152.256,52.832 154.1696,52.3328 L154.1696,41.0176 C152.8384,41.5168 151.5904,41.7664 149.9264,41.7664 C147.0976,41.7664 145.5168,40.352 145.5168,37.1904 L145.5168,19.2192 L154.0864,19.2192 L154.0864,9.0688 L145.5168,9.0688 L145.5168,7.10542736e-15 L130.624,7.10542736e-15 L130.624,9.0688 L125.3824,9.0688 L125.3824,19.2192 L130.624,19.2192 L130.624,38.6048 C130.624,48.8384 136.1152,53.5808 145.9328,53.5808 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.992,52.5824 L175.8848,52.5824 L175.8848,31.9488 C175.8848,24.96 180.8768,22.1312 189.9456,22.3808 L189.9456,8.4864 C183.2064,8.4032 178.6304,11.232 175.8848,17.7216 L175.8848,9.0688 L160.992,9.0688 L160.992,52.5824 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.4848,53.5808 C230.6304,53.5808 238.2016,48.0064 239.5328,38.1888 L225.5552,38.1888 C224.9728,41.1008 222.8928,43.3472 217.984,43.3472 C212.6592,43.3472 209.3312,40.0192 208.9152,34.2784 L239.5328,34.2784 L239.5328,30.368 C239.5328,14.7264 229.2992,7.904 217.4016,7.904 C204.256,7.904 193.856,16.7232 193.856,30.7008 L193.856,31.3664 C193.856,45.5936 203.84,53.5808 217.4848,53.5808 Z M209.0816,25.8752 C209.8304,20.6336 212.9088,17.7216 217.4016,17.7216 C222.2272,17.7216 224.8064,20.6336 225.056,25.8752 L209.0816,25.8752 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.9392,67.1424 L260.832,67.1424 L260.832,46.176 C262.9952,50.5024 267.7376,53.5808 274.3104,53.5808 C284.544,53.5808 292.7808,46.0928 292.7808,31.1168 L292.7808,30.4512 C292.7808,15.5584 284.544,7.904 274.3936,7.904 C267.8208,7.904 263.328,11.3984 260.832,15.5584 L260.832,9.0688 L245.9392,9.0688 L245.9392,67.1424 Z M269.0688,42.1824 C263.6608,42.1824 260.416,38.4384 260.416,31.0336 L260.416,30.368 C260.416,23.0464 263.6608,19.136 269.0688,19.136 C274.3104,19.136 277.6384,22.7968 277.6384,30.4512 L277.6384,31.1168 C277.6384,38.272 274.6432,42.1824 269.0688,42.1824 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.9856,42.5152 C315.2448,42.5152 312.3328,38.4384 312.3328,30.9504 L312.3328,30.2848 C312.3328,22.9632 315.4112,19.0528 320.9856,19.0528 C326.6432,19.0528 329.5552,23.1296 329.5552,30.4512 L329.5552,31.1168 C329.5552,38.3552 326.56,42.5152 320.9856,42.5152 Z M320.9024,53.5808 C334.2976,53.5808 344.6976,45.0944 344.6976,30.9504 L344.6976,30.2848 C344.6976,16.4736 334.3808,7.904 320.9856,7.904 C307.5072,7.904 297.1072,16.7232 297.1072,30.7008 L297.1072,31.3664 C297.1072,45.4272 307.5072,53.5808 320.9024,53.5808 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.1872,52.5824 L366.08,52.5824 L366.08,31.9488 C366.08,24.96 371.072,22.1312 380.1408,22.3808 L380.1408,8.4864 C373.4016,8.4032 368.8256,11.232 366.08,17.7216 L366.08,9.0688 L351.1872,9.0688 L351.1872,52.5824 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.9344,53.5808 C408.4288,53.5808 411.2576,52.832 413.1712,52.3328 L413.1712,41.0176 C411.84,41.5168 410.592,41.7664 408.928,41.7664 C406.0992,41.7664 404.5184,40.352 404.5184,37.1904 L404.5184,19.2192 L413.088,19.2192 L413.088,9.0688 L404.5184,9.0688 L404.5184,7.10542736e-15 L389.6256,7.10542736e-15 L389.6256,9.0688 L384.384,9.0688 L384.384,19.2192 L389.6256,19.2192 L389.6256,38.6048 C389.6256,48.8384 395.1168,53.5808 404.9344,53.5808 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "motif"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFC729",
    cx: 52,
    cy: 52,
    r: 52
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#BE6E07",
    cx: 31.2,
    cy: 33.8,
    r: 5.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#BE6E07",
    cx: 31.2,
    cy: 52,
    r: 5.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3954381,73.0198113 C36.2802518,75.7897408 33.9982427,78 31.2,78 C28.3281193,78 26,75.6718807 26,72.8 C26,69.9281193 28.3281193,67.6 31.2,67.6 C32.3711098,67.6 33.4517983,67.9871397 34.3210682,68.6404218 C33.9935412,69.0741807 33.8,69.6144884 33.8,70.2 C33.8,71.6359403 34.9640597,72.8 36.4,72.8 Z",
    id: "Combined-Shape",
    fill: "#BE6E07"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#BE6E07",
    points: "74.8229452 68.6 82.6 68.6 82.6 76.4 67 76.4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#BE6E07",
    x: 38.4,
    y: 29.6,
    width: 44.2,
    height: 7.8
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#BE6E07",
    points: "38.4 47.8 74.8 47.8 68.1000867 55.6 38.4 55.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BE6E07",
    points: "42.0912352 63.3148771 54.6180404 72.8690629 89.6871287 36.4 96.2 42.7821674 54.7544554 85.8 36.4 70.4621112"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestReportLogoDark);
export default __webpack_public_path__ + "static/media/test-report-logo-dark.85e5da0648a46581b1a453b2cd86eafe.svg";
export { ForwardRef as ReactComponent };